import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoginComponent } from '../header/login/login.component';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ForgotPasswordComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit(): void {
    if (window.screen.width < 500) {
      {
        this.dialogRef.updateSize('95%', 'auto')
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  // openDialog(): void {
  //   const dialogRef = this.dialog.open(LoginComponent, {
  //     width: '60%',

  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     
  //   });
  // }

}
